export const ListRoles = [
    { id: 1, name: 'Админ' },
    { id: 2, name: 'Поставщик' },
    { id: 3, name: 'Клиент' }
];